import script from "./Lucahub.vue?vue&type=script&setup=true&lang=js"
export * from "./Lucahub.vue?vue&type=script&setup=true&lang=js"

import "./Lucahub.vue?vue&type=style&index=0&id=b388a856&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b388a856"]])

export default __exports__